<template>
  <button
    v-if="event && event.status != 2 && !ticket.valid && !ticket.error && !ticket.winner && (typeof ticket.valid !== 'undefined')"
    @click="onClick()"
    class="btn btn-fill btn-icon btn-danger"
    title="Informar erro"
  >
    <i class="ti-close"></i>
  </button>
</template>

<script>
  import swal from 'sweetalert2'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'ticket-invalidate-error',

    props: {
      ticket: {
        type: Object,
        required: true
      },
      type: {
        type: String,
        required: true
      },
      event: {}
    },

    data () {
      return {
      }
    },

    computed: {
      ...mapGetters('project', {
        config: 'project'
      })
    },

    methods: {
      ...mapActions('tickets', ['upsertWithView', 'getTicketsByEvent', 'getTicketsByCustomer']),
      ...mapActions('tickets', {fetchTickets: 'fetchAll'}),
      ...mapActions('customers', { fetchCustomer: 'fetchOne' }),

      onClick () {
        console.log(this.ticket)
        swal({
          title: 'Informe o erro no cadastro',
          input: 'textarea',
          type: '',
          confirmButtonClass: 'btn btn-info btn-fill',
          confirmButtonText: 'Informar'
        }).then((reason) => {
          if (reason) {
            this.invalidateTicket(reason)
          } else {
            swal({
              title: '',
              text: `Necessário informar uma razão para invalidar ticket.`,
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              timer: 3000
            })
            // Somente para não dar erro Uncaught (in promise)
              .then((result) => {}, (dismiss) => {})
          }
        }, () => {})
      },

      async invalidateTicket (reason) {
        let validate = {
          valid: false,
          eligible: false,
          error: true
        }
        const doc = Object.assign({}, this.ticket, validate)
        doc.reasonNotEligible = 'Invalidado por um atendente.'
        doc.reasonError = reason

        return this.upsertWithView({
          find: {
            ddoc: 'tickets-by-id',
            view: 'tickets-by-id',
            key: doc._id
          },
          payload: doc
        })
          .then(() => {
            const options = {
              message: 'Informado erro no ticket, ticket invalidado.',
              type: 'success'
            }

            this.getTickets().then(() => {
              this.$notify(options)
            })
          })
          .catch(err => {
            console.log(err)
            swal({
              title: '',
              text: `Ocorreu um problema ao informar erro no ticket.`,
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            })
          })
      },

      getTickets () {
        if (this.type === 'customer') {
          return this.getTicketsByCustomer(this.ticket.customerId)
        } else if (this.type === 'event') {
          return this.getTicketsByEvent(this.ticket.eventId)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Tickets/Actions/TicketInvalidateError.vue